import { useMemo } from 'react';

import { MarketsErrorMessage } from '../components/MarketsErrorMessage/MarketsErrorMessage';
import { BrowseSkeleton } from '../components/BrowseSkeleton/BrowseSkeleton';
import { MarketSectionsList } from '../components/MarketSectionsList/MarketSectionsList';
import { usePredictionMarketsDiscover } from '../hooks/usePredictionMarketsDiscover';
import { useSectionIds } from '../state/selectors/discover.selectors';
import { useLoadedMarketsPusher } from '../hooks/useLoadedMarketsPusher';

function MarketSections() {
  const sectionIds = useSectionIds();

  useLoadedMarketsPusher();

  const sections = useMemo(
    () =>
      sectionIds.map((section) => ({
        key: section.title,
        title: section.title,
        items: section.marketGroupIds.map((marketGroupId) => ({ marketGroupId })),
      })),
    [sectionIds]
  );

  return <MarketSectionsList sections={sections} />;
}

function MarketBrowsePage() {
  const { isLoading, error } = usePredictionMarketsDiscover();

  if (isLoading) return <BrowseSkeleton />;
  if (error) return <MarketsErrorMessage />;

  return <MarketSections />;
}

export default MarketBrowsePage;
